import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RcsCheckbox from '@Containers/RcsResults/RcsCheckbox/RcsCheckbox';
import { isProductChecked as isProductCheckedSelector } from '@Pages/Results/selectors';
import { setChecked as setCheckedAction } from './actions';

export function RcsCheckboxContainer({ checked, setChecked, productIndex }) {
  return <RcsCheckbox checked={checked} setChecked={setChecked} productIndex={productIndex} />;
}

RcsCheckboxContainer.propTypes = {
  checked: PropTypes.bool,
  setChecked: PropTypes.func.isRequired,
  productIndex: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  return {
    checked: isProductCheckedSelector(state, ownProps),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setChecked: (checked) => dispatch(setCheckedAction(ownProps, checked)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RcsCheckboxContainer);
